import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController, useFocusOptionController } from '../../../internal/hooks/controllers';
import { SELECT_ALL_INDEX } from '../../../internal';
export function useMultiSelectDesktopController(props) {
  var _useDropdownControlle = useDropdownController(props),
    open = _useDropdownControlle.open,
    dropdownActions = _useDropdownControlle.actions;
  var _useFocusOptionContro = useFocusOptionController({
      length: props.options.length,
      minIndex: props.allOption ? SELECT_ALL_INDEX : 0
    }),
    focusedIndex = _useFocusOptionContro.focusedIndex,
    focusOptionActions = _useFocusOptionContro.actions;
  var stateRef = useValueRef({
    props: props,
    open: open,
    focusedIndex: focusedIndex
  });
  var allOptionLabel = React.useMemo(function () {
    if (!props.allOption) {
      return;
    }
    return typeof props.allOption === 'boolean' ? 'Выбрать всё' : props.allOption;
  }, [props.allOption]);
  React.useEffect(function () {
    var _stateRef$current$pro = stateRef.current.props,
      options = _stateRef$current$pro.options,
      value = _stateRef$current$pro.value;
    if (open) {
      return;
    }
    var firstIndex = props.allOption ? SELECT_ALL_INDEX : 0;
    var firstSelectedIndex = props.allOption && value.length === options.length ? SELECT_ALL_INDEX : options.findIndex(function (option) {
      return value.includes(option.value);
    });
    focusOptionActions.setFocusedIndex(Math.max(firstSelectedIndex, firstIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, props.allOption]);
  var setFocusedOptionState = function setFocusedOptionState(nextState) {
    var _stateRef$current = stateRef.current,
      props = _stateRef$current.props,
      focusedIndex = _stateRef$current.focusedIndex;
    var option = props.options[focusedIndex];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = props.value;
    var isChecked = prevValue.includes(optionValue);
    if (isChecked === nextState) {
      return;
    }
    if (nextState) {
      props.onChange([].concat(_toConsumableArray(prevValue), [optionValue]));
    } else {
      props.onChange(prevValue.filter(function (v) {
        return v !== optionValue;
      }));
    }
  };
  var toggleAllOptionState = function toggleAllOptionState() {
    var props = stateRef.current.props;
    var allValues = props.options.map(function (option) {
      return option.value;
    });
    var newValue = props.value.length === props.options.length ? [] : allValues;
    props.onChange(newValue);
  };
  var toggleOptionState = function toggleOptionState(index) {
    var props = stateRef.current.props;
    var option = props.options[index];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = props.value;
    var isChecked = prevValue.includes(optionValue);
    if (isChecked) {
      props.onChange(prevValue.filter(function (v) {
        return v !== optionValue;
      }));
    } else {
      props.onChange([].concat(_toConsumableArray(prevValue), [optionValue]));
    }
  };
  var toggleFocusedOptionState = function toggleFocusedOptionState() {
    var focusedIndex = stateRef.current.focusedIndex;
    if (focusedIndex === SELECT_ALL_INDEX) {
      toggleAllOptionState();
    } else {
      toggleOptionState(stateRef.current.focusedIndex);
    }
  };
  var actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusOptionActions), {}, {
    setFocusedOptionState: setFocusedOptionState,
    toggleFocusedOptionState: toggleFocusedOptionState,
    toggleOptionState: toggleOptionState,
    toggleAllOptionState: toggleAllOptionState
  });
  return {
    open: open,
    focusedIndex: focusedIndex,
    actions: actions,
    allOptionLabel: allOptionLabel
  };
}